const list = [
  {
    title: 'Front End',
    techs: ['React | Redux', 'Javascript', 'HTML', 'CSS | Sass'],
    iconClassname: 'fa fa-desktop fa-fw'
  },
  {
    title: 'Server',
    techs: ['NodeJs', 'Express', 'Python', 'Apache'],
    iconClassname: 'fa fa-server fa-fw'
  },
  {
    title: 'Database',
    techs: ['MySQL', 'MongoDB', 'PostGreSQL'],
    iconClassname: 'fa fa-database fa-fw'
  },
  {
    title: 'Deployment',
    techs: ['nginx', 'Git', 'Heroku', 'Docker'],
    iconClassname: 'fa fa-cloud fa-fw'
  }
];

export { list };
